import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { PagarmeService } from './pagarme.service';
import { LoadingModalComponent } from "../loading-modal/loading-modal.component";
import { AlertComponent } from '../alert/alert.component';

interface ICreditCard {
  endereco: IEndereco;
  cardCvv: string;
  cardMonth: string;
  cardName: string;
  cardNumber: string;
  cardYear: number;
  email: string;
}

type IEndereco = {
  bairro: string;
  cep: string;
  cidade: string;
  estado: string;
  numero: string;
  rua: string;
}

@Component({
  selector: 'app-checkout-pagarme',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatIconModule, LoadingModalComponent, AlertComponent],
  templateUrl: './checkout-pagarme.component.html',
  styleUrls: ['./checkout-pagarme.component.scss'],
  providers: [PagarmeService]
})
export class CheckoutPagarmeComponent implements OnInit {
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;
  @ViewChild(AlertComponent) alertgComponent!: AlertComponent;

  public isShowModal: boolean = false;
  public stepForm: number = 1;
  public emailUser: string = '';
  public typePayment!: string;
  public linkQrCode!: string;
  public codePixPayment!: string;
  public dataCreditCard!: ICreditCard;
  public stepCard: number = 1;

  public estadosBrasil = [
    { sigla: "AC", nome: "Acre" },
    { sigla: "AL", nome: "Alagoas" },
    { sigla: "AP", nome: "Amapá" },
    { sigla: "AM", nome: "Amazonas" },
    { sigla: "BA", nome: "Bahia" },
    { sigla: "CE", nome: "Ceará" },
    { sigla: "DF", nome: "Distrito Federal" },
    { sigla: "ES", nome: "Espírito Santo" },
    { sigla: "GO", nome: "Goiás" },
    { sigla: "MA", nome: "Maranhão" },
    { sigla: "MT", nome: "Mato Grosso" },
    { sigla: "MS", nome: "Mato Grosso do Sul" },
    { sigla: "MG", nome: "Minas Gerais" },
    { sigla: "PA", nome: "Pará" },
    { sigla: "PB", nome: "Paraíba" },
    { sigla: "PR", nome: "Paraná" },
    { sigla: "PE", nome: "Pernambuco" },
    { sigla: "PI", nome: "Piauí" },
    { sigla: "RJ", nome: "Rio de Janeiro" },
    { sigla: "RN", nome: "Rio Grande do Norte" },
    { sigla: "RS", nome: "Rio Grande do Sul" },
    { sigla: "RO", nome: "Rondônia" },
    { sigla: "RR", nome: "Roraima" },
    { sigla: "SC", nome: "Santa Catarina" },
    { sigla: "SP", nome: "São Paulo" },
    { sigla: "SE", nome: "Sergipe" },
    { sigla: "TO", nome: "Tocantins" },
  ];

  public year: number = new Date().getFullYear();
  public years: Array<number> = [];

  constructor(private pagarmeService: PagarmeService) { }

  ngOnInit() {
    this.generateNextYears();
   }


  public handleShowModal(emailUser: string): void {
    this.emailUser = emailUser;
    this.isShowModal = true;
    this.stepForm = 1;
  }

  public generateNextYears(): void {
    for(let i = 0 ; i < 21 ; i++){
      this.years.push(this.year+i)
    }
  }
 
  public handleStepOne() {
    this.stepForm += 1;
  }

  public handleSelectPix() {
    this.typePayment = "pix";
    this.loadingComponent.activeLoading();
    this.pagarmeService.getQrCode(this.emailUser).subscribe((response: any) => {
      this.linkQrCode = response.qrcode
      this.codePixPayment = response.codepix
      this.loadingComponent.inactiveLoading();
    })

  }

  public handleSelectCreditCard() {
    this.typePayment = 'credit-card';
    this.dataCreditCard = {
      endereco: {
        cep: '',
        bairro: '',
        rua: '',
        cidade: '',
        estado: '',
        numero: ''
      },
      cardCvv: '',
      cardMonth: '',
      cardName: '',
      cardNumber: '',
      cardYear: 0,
      email: this.emailUser
    }
  }

  public handleClosePixCardQrcode() {
    this.stepForm = 0;
    this.typePayment = '';
    this.codePixPayment = '';
    this.linkQrCode = '';
    this.isShowModal = false;
  }

  public handleCopyCode() {
    navigator.clipboard.writeText(this.codePixPayment)
      .then(() => {
        this.alertgComponent.showAlert('Codigo copiado com sucesso!', 'success')
      })
      .catch(err => {
        this.alertgComponent.showAlert('Erro ao tentar copiar codigo!', 'error')
      });
  }

  public handleCloseAllModal() {
    this.stepForm = 0;
    this.typePayment = "";
    this.isShowModal = false;
  }

  public handleSearchCep(){


    console.log("Buscando cep: "+this.dataCreditCard.endereco.cep);
    this.handleAddMaskCep();
  }

  public handleAddMaskCep(){
    const newCep: string = this.dataCreditCard.endereco.cep.replace(/[^0-9]/g, "");
    if(newCep.length === 8){
      this.loadingComponent.activeLoading();
      this.dataCreditCard.endereco.cep = newCep.replace(/^(\d{5})(\d{3})$/, "$1-$2");
      this.pagarmeService.getAddress(this.dataCreditCard.endereco.cep).subscribe((response:any )=> {
        this.dataCreditCard.endereco.rua = response.logradouro;
        this.dataCreditCard.endereco.bairro = response.bairro;
        this.dataCreditCard.endereco.cidade = response.localidade;
        this.dataCreditCard.endereco.estado = response.uf;
        this.loadingComponent.inactiveLoading();

      })
    }
  }

  public nextStepCard(){
    if(this.stepCard < 2){
      this.stepCard ++;
    }
  }

  handleSubmitAssign(){
    console.log(this.dataCreditCard);
    this.loadingComponent.activeLoading();
    this.pagarmeService.sendAssign(this.dataCreditCard).subscribe((response: any)=> {
      console.log(response);
      this.loadingComponent.inactiveLoading();
      this.handleCloseAllModal();
      this.alertgComponent.showAlert("Assinatura realizada com sucesso!", "success");
    },(error: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertgComponent.showAlert(`Erro ao tentar realizar a assinatura, motivo: ${error.error.status}`, "error");
    })
  }


}
